import { render, staticRenderFns } from "./AdminDashboardPage.vue?vue&type=template&id=447aa04a"
import script from "./AdminDashboardPage.vue?vue&type=script&lang=ts"
export * from "./AdminDashboardPage.vue?vue&type=script&lang=ts"
import style0 from "./AdminDashboardPage.vue?vue&type=style&index=0&id=447aa04a&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports